import { Switch } from 'antd';
import React, { forwardRef } from 'react'

const SwitchWithLabel = forwardRef(function SwitchWithLabel({ label, labelStyle, containerClassName, ...restProps }, ref) {
    return (
        restProps.leftInlineLabel
        ?
        <span className={containerClassName}><span className="text-bold m-r-sm" style={{verticalAlign: "middle", ...labelStyle}}>{label}</span><Switch size="small" {...restProps} ref={ref} /></span>
        :
        <span className={containerClassName}><Switch size="small" {...restProps} ref={ref} /><span className="text-bold m-l-sm" style={{verticalAlign: "middle", ...labelStyle}}>{label}</span></span>
    )
})

export default SwitchWithLabel;